
import React, { useState, useEffect, useRef } from "react";
import { SideBar } from "../../../../imports";
import excelIcon from "../../../../assets/icons/Excel icon.png";
import pdfIcon from "../../../../assets/icons/Pdf Icon.png";
import { ObtenerFormularios } from "../../../../servicios/ServicioFormulario";
import { ObtenerPersonasCV } from "../../../../servicios/ServicioPersonaCV";
import {
    ObtenerReporteEvaluacion,
    ObtenerReporteEvaluacionFormulario,
} from "../../../../servicios/ServicioEvaluacion";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Select from "react-select";
import PdfReporteEvaluacion from "./PdfReporteEvaluacion";
import { pdf } from "@react-pdf/renderer";

import PdfReporteEvaluacionFormulario from "./PdfReporteEvaluacionFormulario";

export default function PersonasPorFormulario() {
    const [formularios, setFormularios] = useState([]);
    const [evaluados, setEvaluados] = useState([]);
    const [idFormulario, setIdFormulario] = useState("");

    const [rowsFormulario, setRowsFormulario] = useState([]); 
    const [cargando, setCargando] = useState(false);
    const [exportandoPdf, setExportandoPdf] = useState(false);
    const [exportandoExcel, setExportandoExcel] = useState(false);

    
    const [modal, setModal] = useState({
        visible: false,
        tipo: "info",
        titulo: "",
        mensaje: "",
    });

    const mostrarModal = (tipo, titulo, mensaje) => {
        setModal({ visible: true, tipo, titulo, mensaje });
    };

    const cerrarModal = () => {
        setModal((prev) => ({ ...prev, visible: false }));
    };

    const [paginaActual, setPaginaActual] = useState(1);
    const elementosPorPagina = 10;

    const refContenedor = useRef(null);

    useEffect(() => {
        cargarFormularios();
    }, []);

    
    useEffect(() => {
        setRowsFormulario([]);
        setEvaluados([]);
        setPaginaActual(1);
    }, [idFormulario]);

    const normalizarFormularios = (data) => {
        return (data || [])
            .map((f) => ({
                idFormulario: f.idFormulario ?? f.IdFormulario ?? f.id_formulario,
                nombre: f.nombre ?? f.Nombre ?? f.name,
                activo: f.activo ?? f.Activo ?? f.active,
            }))
            .filter((f) => Boolean(f.activo) && f.idFormulario != null);
    };

    const cargarFormularios = async () => {
        try {
            const data = await ObtenerFormularios();
            setFormularios(normalizarFormularios(data));
        } catch (err) {
            console.error("❌ Error cargando formularios:", err);
            setFormularios([]);
            mostrarModal("error", "Error", "Error cargando formularios.");
        }
    };

    const cargarEvaluados = async () => {
        if (!idFormulario) {
            setEvaluados([]);
            setRowsFormulario([]);
            mostrarModal("error", "Error", "Seleccione un formulario antes de buscar.");
            return;
        }

        try {
            setCargando(true);

            const idForm = Number(idFormulario);
            if (!Number.isFinite(idForm)) {
                setEvaluados([]);
                setRowsFormulario([]);
                mostrarModal("error", "Error", "El Id del formulario no es válido.");
                return;
            }

            const data = await ObtenerReporteEvaluacionFormulario(idForm);

            if (!Array.isArray(data)) {
                setEvaluados([]);
                setRowsFormulario([]);
                mostrarModal("error", "Error", "La API no devolvió una lista.");
                return;
            }

            
            setRowsFormulario(data);

            const agrupado = Object.values(
                data.reduce((acc, item) => {
                    const id = item?.IdEvaluado ?? item?.idEvaluado;
                    if (!id) return acc;

                    const nombreBase =
                        item?.NombreEvaluado ??
                        item?.nombreEvaluado ??
                        item?.PrimerNombre ??
                        item?.primerNombre ??
                        "";

                    const ap1 = item?.PrimerApellido ?? item?.primerApellido ?? "";
                    const ap2 = item?.SegundoApellido ?? item?.segundoApellido ?? "";
                    const nombreCompleto = `${nombreBase} ${ap1} ${ap2}`.trim();

                    const fecha =
                        item?.FechaCreacion ??
                        item?.fechaCreacion ??
                        item?.Fec ??
                        item?.fec ??
                        "";

                    if (!acc[id] || (fecha && fecha > acc[id].fecha)) {
                        acc[id] = {
                            idEvaluado: id,
                            nombreEvaluado: nombreCompleto || `ID ${id}`,
                            fecha: fecha,
                        };
                    }
                    return acc;
                }, {})
            );

            setEvaluados(agrupado);
            setPaginaActual(1);

            
            if (agrupado.length === 0) {
                mostrarModal(
                    "info",
                    "Sin resultados",
                    "No hay personas que hayan completado este formulario."
                );
            }
        } catch (err) {
            console.error("❌ Error cargando evaluados:", err);
            setEvaluados([]);
            setRowsFormulario([]);
            mostrarModal(
                "error",
                "Error",
                "Error consultando el reporte. Revise consola / Network."
            );
        } finally {
            setCargando(false);
        }
    };

    const formularioSeleccionado = formularios.find(
        (f) => String(f.idFormulario) === String(idFormulario)
    );

    const totalPaginas = Math.ceil(evaluados.length / elementosPorPagina);

    const exportarPdfFormulario = async () => {
        if (!idFormulario) {
            mostrarModal("error", "Error", "Seleccione un formulario primero.");
            return;
        }
        if (!rowsFormulario.length) {
            mostrarModal(
                "error",
                "Error",
                "No hay datos para exportar. Primero presione buscar."
            );
            return;
        }

        try {
            setExportandoPdf(true);

            const getNombreCompleto = (r) => {
                const nombreBase =
                    r?.NombreEvaluado ??
                    r?.nombreEvaluado ??
                    r?.PrimerNombre ??
                    r?.primerNombre ??
                    "";

                const ap1 = r?.PrimerApellido ?? r?.primerApellido ?? "";
                const ap2 = r?.SegundoApellido ?? r?.segundoApellido ?? "";

                return `${nombreBase} ${ap1} ${ap2}`.trim();
            };

            const getFecha = (r) =>
                r?.FechaCreacion ?? r?.fechaCreacion ?? r?.Fec ?? r?.fec ?? "";

            const map = rowsFormulario.reduce((acc, r) => {
                const id = r?.IdEvaluado ?? r?.idEvaluado;
                if (!id) return acc;

                if (!acc[id]) {
                    const nombreCompleto = getNombreCompleto(r);
                    acc[id] = {
                        idEvaluado: id,
                        nombre: nombreCompleto || "",
                        nombreEvaluado: nombreCompleto || "",
                        fecha: getFecha(r),
                    };
                }

                const f = getFecha(r);
                if (f && (!acc[id].fecha || f > acc[id].fecha)) acc[id].fecha = f;

                return acc;
            }, {});

            const personas = Object.values(map).sort((a, b) =>
                (b.fecha || "").localeCompare(a.fecha || "")
            );

            const doc = (
                <PdfReporteEvaluacionFormulario
                    formulario={{
                        id: idFormulario,
                        nombre: formularioSeleccionado?.nombre || "Formulario",
                    }}
                    personas={personas}
                />
            );

            const blob = await pdf(doc).toBlob();
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `Reporte_Formulario_${idFormulario}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("❌ Error exportando PDF:", err);
            mostrarModal("error", "Error", "Error exportando PDF.");
        } finally {
            setExportandoPdf(false);
        }
    };

    
    const exportarExcelFormulario = async () => {
        if (!idFormulario) {
            mostrarModal("error", "Error", "Seleccione un formulario primero.");
            return;
        }
        if (!rowsFormulario.length) {
            mostrarModal("error", "Error", "No hay datos para exportar. Primero presione buscar.");
            return;
        }

        try {
            setExportandoExcel(true);

            const getNombreCompleto = (r) => {
                const nombreBase =
                    r?.NombreEvaluado ??
                    r?.nombreEvaluado ??
                    r?.PrimerNombre ??
                    r?.primerNombre ??
                    "";

                const ap1 = r?.PrimerApellido ?? r?.primerApellido ?? "";
                const ap2 = r?.SegundoApellido ?? r?.segundoApellido ?? "";

                return `${nombreBase} ${ap1} ${ap2}`.trim();
            };

            const getFecha = (r) =>
                r?.FechaCreacion ?? r?.fechaCreacion ?? r?.Fec ?? r?.fec ?? "";

            const map = rowsFormulario.reduce((acc, r) => {
                const id = r?.IdEvaluado ?? r?.idEvaluado;
                if (!id) return acc;

                const nombre = getNombreCompleto(r);
                const fecha = getFecha(r);

                if (!acc[id]) {
                    acc[id] = { idEvaluado: id, nombreEvaluado: nombre || "", fecha: fecha || "" };
                } else {
                    if (fecha && (!acc[id].fecha || fecha > acc[id].fecha)) acc[id].fecha = fecha;
                    if (!acc[id].nombreEvaluado && nombre) acc[id].nombreEvaluado = nombre;
                }
                return acc;
            }, {});

            const personas = Object.values(map)
                .map((p) => ({
                    evaluado: p.nombreEvaluado || `ID ${p.idEvaluado}`,
                    fecha: p.fecha || "",
                }))
                .sort((a, b) => String(b.fecha || "").localeCompare(String(a.fecha || "")));

            const nombreForm = (formularioSeleccionado?.nombre || "Formulario").replace(
                /[\\/:*?"<>|]/g,
                "-"
            );

            const escapeHtml = (s) =>
                String(s ?? "")
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");

            const emerald = "#059669";
            const emeraldDark = "#047857";
            const grayBorder = "#E5E7EB";
            const grayText = "#111827"; 

            const fmtFecha = (f) => {
                if (!f) return "";
                return String(f).replace("T", " ").substring(0, 16);
            };

            
            const titleSize = 30;   
            const labelSize = 14;   
            const metaSize = 18;    
            const headerSize = 18;  
            const rowSize = 18;     

            const html = `
      <html>
      <head>
        <meta charset="utf-8" />
      </head>
      <body style="font-family: Calibri, Arial, sans-serif; padding:14px;">
        <table style="border-collapse:collapse; width:100%;">
          <colgroup>
            <col style="width:520px;" />
            <col style="width:320px;" />
          </colgroup>

          <!-- TÍTULO -->
          <tr>
            <td colspan="2"
                style="font-size:${titleSize}px; font-weight:900; color:${emeraldDark};
                       padding:14px 16px; border:1px solid ${grayBorder};">
              Personas que realizaron el formulario
            </td>
          </tr>

          <!-- METADATA -->
          <tr>
            <td style="padding:12px 16px; border:1px solid ${grayBorder}; color:${grayText};">
              <div style="font-size:${labelSize}px; font-weight:900; letter-spacing:.08em;">
                FORMULARIO
              </div>
              <div style="font-size:${metaSize}px; font-weight:800; margin-top:4px;">
                ${escapeHtml(nombreForm)}
              </div>
            </td>

            <td style="padding:12px 16px; border:1px solid ${grayBorder}; color:${grayText}; text-align:right;">
              <span style="font-size:${metaSize}px; font-weight:900;">Total de personas:</span>
              <span style="font-size:${metaSize}px; font-weight:800;"> ${personas.length}</span>
            </td>
          </tr>

          <!-- ESPACIO -->
          <tr>
            <td colspan="2" style="height:12px;"></td>
          </tr>

          <!-- ENCABEZADOS -->
          <tr>
            <th style="background:${emerald}; color:#fff; text-align:left;
                       padding:12px 16px; border:1px solid ${emeraldDark};
                       font-size:${headerSize}px; font-weight:900;">
              Evaluado
            </th>
            <th style="background:${emerald}; color:#fff; text-align:left;
                       padding:12px 16px; border:1px solid ${emeraldDark};
                       font-size:${headerSize}px; font-weight:900;">
              Fecha última evaluación
            </th>
          </tr>

          <!-- FILAS -->
          ${personas
                    .map((p, i) => {
                        const bg = i % 2 === 0 ? "#FFFFFF" : "#ECFDF5";
                        return `
                <tr style="background:${bg};">
                  <td style="padding:12px 16px; border:1px solid ${grayBorder};
                             color:${grayText}; font-size:${rowSize}px; font-weight:700;">
                    ${escapeHtml(p.evaluado)}
                  </td>
                  <td style="padding:12px 16px; border:1px solid ${grayBorder};
                             color:${grayText}; font-size:${rowSize}px; font-weight:700;">
                    ${escapeHtml(fmtFecha(p.fecha))}
                  </td>
                </tr>
              `;
                    })
                    .join("")}
        </table>
      </body>
      </html>
    `;

            const blob = new Blob([html], { type: "application/vnd.ms-excel;charset=utf-8" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `Reporte_Formulario_${idFormulario}_${nombreForm}.xls`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("❌ Error exportando Excel:", err);
            mostrarModal("error", "Error", "Error exportando Excel.");
        } finally {
            setExportandoExcel(false);
        }
    };



    return (
        <div className="flex flex-row min-h-screen bg-gradient-to-br from-gray-50 to-emerald-50">
            <div className="md:basis-1/4 xl:basis-1/5">
                <SideBar />
            </div>

            <div className="md:basis-3/4 xl:basis-11/12 p-8" ref={refContenedor}>
                <div className="bg-white rounded-3xl shadow-xl px-10 py-10 border border-gray-100">
                    <h1 className="text-3xl font-bold text-emerald-700 mb-2">
                        Personas que realizaron el formulario
                    </h1>

                    <p className="text-gray-600 mb-8 text-sm">
                        Seleccione un formulario para ver todas las personas que han completado evaluaciones.
                    </p>

                    
                    <div className="flex flex-col md:flex-row gap-4 mb-6 items-end">
                        <div className="flex-1 flex flex-col">
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
                                Formulario
                            </label>

                            <Select
                                options={formularios.map((f) => ({
                                    value: f.idFormulario,
                                    label: f.nombre,
                                }))}
                                value={
                                    formularioSeleccionado
                                        ? {
                                            value: formularioSeleccionado.idFormulario,
                                            label: formularioSeleccionado.nombre,
                                        }
                                        : null
                                }
                                onChange={(selected) =>
                                    setIdFormulario(selected ? String(selected.value) : "")
                                }
                                placeholder="Seleccione un formulario..."
                                isClearable
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: "48px",
                                        borderRadius: "1rem",
                                    }),
                                }}
                            />
                        </div>

                        <button
                            onClick={cargarEvaluados}
                            disabled={cargando}
                            className="
                w-full md:w-[56px]
                h-[48px]
                bg-emerald-600
                text-white font-semibold
                rounded-2xl
                hover:bg-emerald-700
                transition shadow-lg
                flex items-center justify-center"
                            title="Buscar"
                        >
                            {cargando ? "Buscando…" : "🔍"}
                        </button>
                    </div>

                    
                    {rowsFormulario.length > 0 && (
                        <div className="flex justify-end mb-8 gap-3">
                            {/* Botón Excel */}
                            <button
                                onClick={exportarExcelFormulario}
                                disabled={exportandoExcel}
                                className="
        px-6
        py-3
        rounded-2xl
        transition shadow-lg
        flex items-center justify-center gap-2
        bg-gray-200 text-gray-800 hover:bg-gray-300
        disabled:opacity-60 disabled:cursor-not-allowed
      "
                                title="Exportar Excel"
                            >
                                <img
                                    src={excelIcon}
                                    alt="Excel"
                                    className="w-5 h-5 object-contain"
                                />
                                <span className="font-semibold">
                                    {exportandoExcel ? "Generando..." : "Exportar Excel"}
                                </span>
                            </button>

                            
                            <button
                                onClick={exportarPdfFormulario}
                                disabled={exportandoPdf}
                                className="
        px-6
        py-3
        rounded-2xl
        transition shadow-lg
        flex items-center justify-center gap-2
        bg-gray-900 text-white hover:bg-black
        disabled:opacity-60 disabled:cursor-not-allowed
      "
                                title="Descargar PDF"
                            >
                                <img
                                    src={pdfIcon}
                                    alt="PDF"
                                    className="w-5 h-5 object-contain"
                                />
                                <span className="font-semibold">
                                    {exportandoPdf ? "Generando PDF..." : "Descargar PDF"}
                                </span>
                            </button>
                        </div>
                    )}


                    
                    {evaluados.length > 0 && (
                        <>
                            <div className="overflow-x-auto border border-gray-200 rounded-2xl shadow-sm mb-6">
                                <table className="min-w-full divide-y divide-gray-200 text-sm">
                                    <thead className="bg-emerald-600 text-white">
                                        <tr>
                                            <th className="px-6 py-3 text-left font-semibold">Evaluado</th>
                                            <th className="px-6 py-3 text-left font-semibold">
                                                Fecha última evaluación
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white divide-y divide-gray-100">
                                        {evaluados
                                            .slice(
                                                (paginaActual - 1) * elementosPorPagina,
                                                paginaActual * elementosPorPagina
                                            )
                                            .map((e) => (
                                                <tr key={e.idEvaluado} className="hover:bg-emerald-50 transition">
                                                    <td className="px-6 py-4">{e.nombreEvaluado}</td>
                                                    <td className="px-6 py-4">{e.fecha || "—"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="flex justify-center items-center space-x-2 mb-8">
                                {Array.from({ length: totalPaginas }).map((_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setPaginaActual(i + 1)}
                                        className={`px-3 py-1 rounded-md text-sm font-medium transition ${paginaActual === i + 1
                                                ? "bg-emerald-600 text-white shadow"
                                                : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                            }`}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                            </div>
                        </>
                    )}

                    
                </div>
            </div>

            
            {modal.visible && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
                    onClick={cerrarModal}
                >
                    <div
                        className="bg-white rounded-2xl shadow-xl w-[520px] max-w-[92vw] relative overflow-hidden"
                        onClick={(e) => e.stopPropagation()}
                    >
                        
                        <div className="absolute left-0 top-0 bottom-0 w-2 bg-[#EF4444]" />

                        <div className="p-10 text-center">
                            
                            <div className="flex justify-center mb-5">
                                <div className="w-16 h-16 rounded-full border-4 border-[#EF4444] flex items-center justify-center">
                                    <span className="text-[#EF4444] text-4xl font-bold leading-none">×</span>
                                </div>
                            </div>

                            
                            <h2 className="text-2xl font-bold text-[#EF4444] mb-3">
                                {modal.titulo || "Aviso"}
                            </h2>

                            
                            <p className="text-gray-700 text-lg leading-relaxed mb-8 whitespace-pre-line">
                                {modal.mensaje}
                            </p>

                            
                            <button
                                onClick={cerrarModal}
                                className="px-10 py-3 rounded-xl bg-[#EF4444] text-white font-semibold shadow-md hover:bg-[#DC2626] transition"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
